import { ImagePlus } from "lucide-react";

export const PhotoFrame = ({ label, className = "", dark = false, testId, src, fit = "cover", position = "center" }) =>
  src ? (
    <figure data-testid={testId || "photo"} className={`group relative overflow-hidden ${fit === "contain" ? "bg-white" : "bg-navy"} ${className}`}>
      <img
        src={src}
        alt={label}
        loading="lazy"
        style={{ objectPosition: position }}
        className={`absolute inset-0 h-full w-full transition-transform duration-[1.6s] ease-out group-hover:scale-[1.04] ${fit === "contain" ? "object-contain p-8 md:p-12" : "object-cover"}`}
      />
      {fit === "cover" && <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy/35 via-transparent to-transparent" />}
      <div className="pointer-events-none absolute inset-4 border border-white/40" />
      <span className="pointer-events-none absolute left-4 top-4 h-5 w-5 border-l-2 border-t-2 border-gold" />
      <span className="pointer-events-none absolute bottom-4 right-4 h-5 w-5 border-b-2 border-r-2 border-gold" />
    </figure>
  ) : (
  <figure
    data-testid={testId || "photo-placeholder"}
    className={`photo-frame group relative overflow-hidden ${dark ? "bg-navy-deep text-white/80" : "bg-mist text-slate2"} ${className}`}
  >
    <div className="absolute inset-0 photo-hatch opacity-60 transition-opacity duration-700 group-hover:opacity-90" />
    <div className="absolute inset-4 border border-gold/50" />
    <span className="absolute left-4 top-4 h-5 w-5 border-l-2 border-t-2 border-gold" />
    <span className="absolute bottom-4 right-4 h-5 w-5 border-b-2 border-r-2 border-gold" />
    <figcaption className="relative flex h-full min-h-[inherit] flex-col items-center justify-center gap-3 p-8 text-center">
      <ImagePlus className="h-7 w-7 text-gold" strokeWidth={1.2} />
      <span className="text-[11px] font-semibold uppercase tracking-[0.26em]">Fotografia in arrivo</span>
      <span className="max-w-[16rem] text-xs leading-relaxed opacity-80">{label}</span>
    </figcaption>
  </figure>
);

export const Todo = ({ children, className = "" }) => (
  <span
    data-testid="content-placeholder"
    className={`inline-block rounded-md border border-dashed border-rosso/60 bg-rosso/5 px-2 py-0.5 text-[0.9em] font-medium text-rosso ${className}`}
  >
    [{children}]
  </span>
);
